import { useState, useEffect, useCallback, useMemo, useRef, Fragment } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { FaWhatsapp } from 'react-icons/fa'
import { EVENTO_CHAMAR, type ChamarPedido } from './ConversasPanel'
import { PanelShell, PlnBarra, PlnBarraRot, PlnBarraSep, PlnKpis, PlnKpi, PlnBloco, stickyTh } from './PanelShell'
import { SideModal } from './SideModal'
import ConfirmDialog from './ConfirmDialog'
import {
  FiLoader, FiSearch, FiX, FiRefreshCw, FiDownload, FiAlertTriangle, FiInfo,
  FiChevronUp, FiChevronDown, FiChevronRight, FiClock, FiGift, FiUpload, FiSend, FiCheck, FiRotateCcw, FiPrinter,
} from 'react-icons/fi'
import { NeuSwitch } from './NeuSwitch'

// Painel Incentivos (23/09/2026) — as promoções de indicação que o diretor
// monta no Draco: a regra cadastrada e a classificação (substitui o relatório
// "Classificação de Promoção" em .xls).
//
// NÃO é o painel Incentivos do corte.twms, apesar do nome: lá fica quem JÁ TEM
// brinde para receber (a entrega); aqui é onde a promoção é MONTADA — quem
// pontua e em que faixa. Por isso a lista de entrega do Draco (PROMENTBRINDES)
// não aparece aqui (decisão do diretor, 23/09).
//
// A classificação vem ao vivo do Draco, lido pelo crm (/api/promocoes-draco).
// A promoção é montada e apurada LÁ; uma cópia aqui só serviria para ficar velha.
//
// A regra (PROMINDICACAO): cada recruta lançada no período vale 1 ponto se os
// pedidos dela na janela de análise somam entre o mínimo e o máximo, e 2 pontos
// acima do máximo — e para aí (confirmado pelo diretor).
//
// Clicar numa pessoa abre as RECRUTAS dela, na mesma leitura do painel
// Incentivos do corte.twms: quem foi lançada nas semanas da promoção, a venda
// semana a semana (as da promoção + as duas seguintes), o débito em aberto e
// a devolução desde o lançamento.
//
// O PRÊMIO NO APP (23/09/2026, pedido do diretor): aqui sobem as fotos do brinde
// de 1 ponto e do de 2 pontos; selecionando as pessoas, o botão Avisar libera o
// prêmio no app.twms (aba Prêmio) e manda a mensagem no WhatsApp. Lá ela troca
// os pontos por brindes — troca exata, sem sobra — e a escolha aparece na aba
// Classificação, em destaque verde, com os itens e a data (filtro "Já escolheram").
// Os dados do prêmio moram no app (lib/incentivo.js lá).

interface Promo {
  numero: number
  nome: string | null
  semanaIni: number | null
  semanaFim: number | null
  entregaIni: number | null
  entregaFim: number | null
  situacao: string | null
  pessoas: number
  pontos: number
  indicacoes: number
}

interface Pessoa {
  codigo: string
  nome: string | null
  grupo: string | null
  grupoNome: string | null
  distrito: string | null
  distritoNome: string | null
  tipo: string | null
  semanasAtivas: number
  indicacoes: number
  vendas: number
  pontos: number
  faixa: number
  pontosBrindes: number
  posicao: number
}

interface Detalhe {
  promocao: Promo & { compoeBrindes: boolean }
  regra: null | {
    valorMin: number
    valorMax: number
    semanasAnalise: number
    semanasAtivasMin: number
    indicanteAtivo: boolean
    indicanteValorMin: number | null
    indicanteSemanaIni: number | null
    indicanteSemanaFim: number | null
  }
  faixas: { pontos: number; nome: string | null; brindes: { codigo: string; nome: string | null }[] }[]
  pessoas: Pessoa[]
}

interface Recrutas {
  promocao: { numero: number; nome: string | null; semanaIni: number; semanaFim: number }
  pessoa: { codigo: string; nome: string | null }
  semanaAtual: number
  colunas: boolean
  semanas: { semana: number; depois: boolean; atual: boolean }[]
  quantidade: number
  totalVenda: number
  vendaDepois: number
  totalDebito: number
  totalDevolvido: number
  totalPontos: number
  regra: { valorMin: number; valorMax: number; semanasAnalise: number } | null
  recrutas: {
    codigo: string
    nome: string | null
    lancamento: number
    vendas: (number | null)[]
    debitos: (number | null)[]
    total: number
    depois: number
    debito: number
    devolucoes: { semana: number; valor: number }[]
    devolvido: number
    /** Semana do lançamento + as de análise: a soma dela dá o ponto. */
    janela: number[]
    valorJanela: number
    pontos: number
    /** Hoje está na BASE DISTRIBUIÇÃO (o Draco reescreve a indicante); voltou para cá pelo retrato da semana. */
    foiParaBase?: boolean
  }[]
}
type ItemEscolhido = { qtd: number; nome: string; pts: number; item: string }
type EstadoRecrutas = { loading: boolean; error: string | null; data: Recrutas | null }

// O prêmio no app (app-twms, lib/incentivo.js).
// 05/11/2026: a escolha virou lista de itens (código do brinde no Draco). As
// antigas (911) chegam como itens `p1`/`p2` — o app converte.
interface Escolha { itens: { item: string; qtd: number }[]; qtd1?: number; qtd2?: number; registrada_em: string }
type BrindeApp = { item: string; pontos: number; nome: string | null; arquivo: string | null; url: string | null }
interface PessoaPremio {
  codigo: string
  nome: string | null
  pontos: number
  liberada_em: string | null
  avisada_em: string | null
  aviso_status: 'enviado' | 'sem_celular' | 'erro' | null
  aviso_erro: string | null
  escolha: Escolha | null
}
interface Premio {
  promo: { numero: number; nome: string | null; titulo: string | null; liberada_em: string | null } | null
  brindes: BrindeApp[]
  pessoas: PessoaPremio[]
  reabertas: { codigo: string; itens: { item: string; qtd: number }[]; registrada_em: string; reaberta_em: string; reaberta_por: string | null }[]
  modelo: { nome: string; aprovado: boolean | null; erro: string | null }
  envio: null | { rodando: boolean; total: number; feitos: number; enviados: number; semCelular: number; erros: number; por: string | null; falha?: string }
}

const brl = (n: number) => Number(n || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
const brlCurto = (n: number) => n >= 100000
  ? `R$ ${(n / 1000).toLocaleString('pt-BR', { maximumFractionDigits: 1 })} mil`
  : brl(n)
const num = (n: number) => Number(n || 0).toLocaleString('pt-BR')
// Nas células das recrutas o "R$" repetido em cada coluna tirava o Total e o
// Débito da tela de 1366 — o resumo acima diz que é dinheiro.
const val = (n: number) => Number(n || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
// 202621 → "S21/2026". O Draco conta tudo em semana; converter para data
// inventaria um calendário que não é o dele.
const sem = (n: number | null) => (n ? `S${String(n).slice(4)}/${String(n).slice(0, 4)}` : '—')
const periodo = (a: number | null, b: number | null) => {
  if (!a || !b) return '—'
  return String(a).slice(0, 4) === String(b).slice(0, 4)
    ? `S${String(a).slice(4)}–S${String(b).slice(4)}/${String(b).slice(0, 4)}`
    : `${sem(a)} a ${sem(b)}`
}
const TIPO: Record<string, string> = { '0': 'Ger. distribuição', '1': 'Ger. distrito', '2': 'Líder', '3': 'Consultora' }
const tipoTxt = (t: string | null) => (t != null && TIPO[t]) || (t ? `tipo ${t}` : '')
// Nome da faixa vem digitado à mão no Draco ("4 pontos", "PONTO", "pontos") —
// a tela usa o número, que é o que decide o prêmio.
const faixaTxt = (p: number) => (p === 1 ? '1 ponto' : `${p} pontos`)
const brindeCurto = (s: string | null) => (s || '').replace(/\s+/g, ' ').trim()
const dataHora = (s: string | null) => (s ? `${String(s).slice(0, 10).split('-').reverse().join('/')} ${String(s).slice(11, 16)}` : '')
const dataCurta = (s: string | null) => (s ? String(s).slice(0, 10).split('-').reverse().slice(0, 2).join('/') : '')
const escolhaTxt = (e: Escolha) => { const n = (e.itens || []).reduce((t, i) => t + i.qtd, 0); return `${n} ${n === 1 ? 'brinde' : 'brindes'}` }
// Os brindes do Draco como catálogo: cada um é um item que custa os pontos da faixa.
type ItemCatalogo = { item: string; pontos: number; nome: string | null; faixa: string | null }
const catalogoDe = (det: Detalhe | null): ItemCatalogo[] => (det?.faixas || []).flatMap(f =>
  f.brindes.filter(b => b.codigo).map(b => ({ item: String(b.codigo), pontos: f.pontos, nome: b.nome, faixa: f.nome })))
// "INDIQUE FACIL VT09-33A362026" → "Indique Fácil": o palpite do nome no app
// (o mesmo do app-twms, lib/incentivo.js `tituloDe`). O escritório corrige.
function tituloDe(nome: string | null) {
  // "Indique Fácil" é o nome do 1º prêmio (R$ 399), não da promoção (líderes, 23/09/2026).
  if (/INDIQUE\s+F[AÁ]CIL|INDICA[CÇ][AÃ]O/i.test(String(nome || ''))) return 'Fechamento Indicação'
  const base = String(nome || '').replace(/\s+VT\s*\d.*$/i, '').replace(/\s+\d{2,}.*$/, '').trim()
  if (!base) return ''
  const acentos: Record<string, string> = { FACIL: 'Fácil', INDICACAO: 'Indicação', PROMOCAO: 'Promoção', PREMIO: 'Prêmio' }
  return base.split(/\s+/).map(w => acentos[w.toUpperCase()] || (w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())).join(' ')
}
const primeiro = (n: string | null) => {
  const p = String(n || '').trim().split(/\s+/)[0] || ''
  return p.charAt(0).toUpperCase() + p.slice(1).toLowerCase()
}

export function IncentivosPanel() {
  const { authenticatedFetch } = useAuth()
  const [promos, setPromos] = useState<Promo[]>([])
  const [numero, setNumero] = useState<number | null>(null)
  const [det, setDet] = useState<Detalhe | null>(null)
  const [loadingLista, setLoadingLista] = useState(true)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [q, setQ] = useState('')
  const [fDistrito, setFDistrito] = useState('')
  const [ord, setOrd] = useState<{ col: string; dir: number }>({ col: 'posicao', dir: 1 })
  const [baixando, setBaixando] = useState(false)
  // Pessoas abertas (dá para abrir várias) e o que já veio do Draco para cada
  // uma — fechar e abrir de novo não consulta outra vez.
  const [abertas, setAbertas] = useState<Set<string>>(new Set())
  const [recrutas, setRecrutas] = useState<Map<string, EstadoRecrutas>>(new Map())
  // O prêmio no app.
  const [premio, setPremio] = useState<Premio | null>(null)
  const [premioErro, setPremioErro] = useState('')
  // Uma lista só (23/09/2026, pedido do diretor): quem já escolheu fica em
  // destaque na própria Classificação, e o filtro separa quem falta.
  const [fStatus, setFStatus] = useState<'' | 'escolheu' | 'falta' | 'nao_liberada'>('')
  const [reabrindo, setReabrindo] = useState<string | null>(null)
  const [verLog, setVerLog] = useState(false)
  const [sel, setSel] = useState<Set<string>>(new Set())
  const [avisar, setAvisar] = useState(false)
  // A chave do Prêmio no app.twms (06/10/2026): fechado = a aba some para todos.
  const [appAcesso, setAppAcesso] = useState<{ aberto: boolean; por: string | null; em: string | null } | null>(null)
  const [trocandoApp, setTrocandoApp] = useState(false)
  const [confirmarApp, setConfirmarApp] = useState(false)

  const getJson = useCallback(async (url: string, init?: RequestInit) => {
    const r = await authenticatedFetch(url, init)
    const d = await r.json().catch(() => null)
    if (!r.ok || !d?.success) throw new Error(d?.error || `erro ${r.status}`)
    return d
  }, [authenticatedFetch])

  const lerAppAcesso = useCallback(async () => {
    try { const d = await getJson('/api/incentivos/app-acesso'); setAppAcesso({ aberto: !!d.aberto, por: d.por || null, em: d.em || null }) }
    catch { setAppAcesso(null) }
  }, [getJson])
  useEffect(() => { lerAppAcesso() }, [lerAppAcesso])
  // Confirmação no diálogo do fin, nunca o confirm() do navegador.
  const trocarAppAcesso = async () => {
    if (!appAcesso || trocandoApp) return
    const abrir = !appAcesso.aberto
    setConfirmarApp(false)
    setTrocandoApp(true)
    try {
      const d = await getJson('/api/incentivos/app-acesso', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ aberto: abrir }) })
      setAppAcesso({ aberto: !!d.aberto, por: d.por || null, em: d.em || null })
    } catch (e: any) { setError(`Não consegui mudar o acesso ao app: ${e.message}`) }
    finally { setTrocandoApp(false) }
  }

  const carregarLista = useCallback(async () => {
    setLoadingLista(true)
    try {
      const d = await getJson('/api/incentivos')
      setPromos(d.promocoes || [])
      // Abre na mais recente JÁ APURADA: a que está sendo montada ainda não
      // tem ranking, e abrir o painel numa tela vazia esconde o que ele quer ver.
      setNumero(n => n ?? (d.promocoes.find((p: Promo) => p.pessoas > 0) || d.promocoes[0])?.numero ?? null)
      setError('')
    } catch (e: any) {
      setError(`Não consegui ler as promoções do Draco: ${e.message}`)
    } finally {
      setLoadingLista(false)
    }
  }, [getJson])

  const carregarDetalhe = useCallback(async (n: number) => {
    setLoading(true)
    try {
      const d = await getJson(`/api/incentivos/${n}`)
      setDet(d)
      setError('')
    } catch (e: any) {
      setDet(null)
      setError(`Não consegui ler a promoção ${n}: ${e.message}`)
    } finally {
      setLoading(false)
    }
  }, [getJson])

  const carregarPremio = useCallback(async (n: number) => {
    try {
      const d = await getJson(`/api/incentivos/${n}/premio`)
      setPremio(d)
      setPremioErro('')
      return d as Premio
    } catch (e: any) {
      setPremioErro(`Não consegui ler o prêmio no app: ${e.message}`)
      return null
    }
  }, [getJson])

  useEffect(() => { carregarLista() }, [carregarLista])
  useEffect(() => { if (numero != null) carregarDetalhe(numero) }, [numero, carregarDetalhe])
  useEffect(() => {
    setAbertas(new Set()); setRecrutas(new Map()); setSel(new Set()); setPremio(null)
    if (numero != null) carregarPremio(numero)
  }, [numero, carregarPremio])

  // Enquanto o aviso sai (em segundo plano no fin), acompanha a cada 2 s.
  const rodando = !!premio?.envio?.rodando
  useEffect(() => {
    if (!rodando || numero == null) return
    const t = setInterval(() => carregarPremio(numero), 2000)
    return () => clearInterval(t)
  }, [rodando, numero, carregarPremio])

  const carregarRecrutas = useCallback(async (codigo: string) => {
    if (numero == null) return
    setRecrutas(m => new Map(m).set(codigo, { loading: true, error: null, data: null }))
    try {
      const d = await getJson(`/api/incentivos/${numero}/recrutas/${codigo}`)
      setRecrutas(m => new Map(m).set(codigo, { loading: false, error: null, data: d }))
    } catch (e: any) {
      setRecrutas(m => new Map(m).set(codigo, { loading: false, error: `Não consegui ler as recrutas no Draco: ${e.message}`, data: null }))
    }
  }, [numero, getJson])

  const alternar = (codigo: string) => {
    const abrir = !abertas.has(codigo)
    setAbertas(a => {
      const n = new Set(a)
      if (abrir) n.add(codigo); else n.delete(codigo)
      return n
    })
    if (abrir && (!recrutas.has(codigo) || recrutas.get(codigo)?.error)) carregarRecrutas(codigo)
  }

  const recarregar = () => {
    carregarLista()
    if (numero != null) { carregarDetalhe(numero); carregarPremio(numero) }
    setRecrutas(new Map())
    abertas.forEach(c => carregarRecrutas(c))
  }

  const pessoas = det?.pessoas || []
  const noApp = useMemo(() => new Map((premio?.pessoas || []).map(p => [p.codigo, p])), [premio])

  const distritos = useMemo(() => {
    const m = new Map<string, string>()
    for (const p of pessoas) if (p.distrito) m.set(p.distrito, p.distritoNome || p.distrito)
    return [...m.entries()].sort((a, b) => a[1].localeCompare(b[1]))
  }, [pessoas])

  const casa = useCallback((codigo: string, nome: string | null, p: Pessoa | null) => {
    if (fDistrito && p?.distrito !== fDistrito) return false
    const t = q.trim().toLowerCase()
    if (!t) return true
    return (nome || '').toLowerCase().includes(t) || codigo.includes(t) ||
      (p?.grupoNome || '').toLowerCase().includes(t) || (p?.grupo || '').includes(t)
  }, [q, fDistrito])

  const statusDe = useCallback((p: Pessoa) => {
    const a = noApp.get(p.codigo)
    return a?.escolha ? 'escolheu' : a ? 'falta' : 'nao_liberada'
  }, [noApp])
  const contaStatus = useMemo(() => {
    const c: Record<string, number> = { escolheu: 0, falta: 0, nao_liberada: 0 }
    for (const p of pessoas) if (casa(p.codigo, p.nome, p)) c[statusDe(p)]++
    return c
  }, [pessoas, casa, statusDe])

  const filtradas = useMemo(() => {
    const f = pessoas.filter(p => casa(p.codigo, p.nome, p) && (!fStatus || statusDe(p) === fStatus))
    const ordemPremio = (p: Pessoa) => {
      const a = noApp.get(p.codigo)
      return a?.escolha ? 4 : a?.aviso_status === 'enviado' ? 3 : a?.aviso_status ? 2 : a ? 1 : 0
    }
    const get: Record<string, (p: Pessoa) => any> = {
      posicao: p => p.posicao, nome: p => p.nome || '', grupo: p => p.grupoNome || '',
      distrito: p => p.distritoNome || '', ativ: p => p.semanasAtivas, ind: p => p.indicacoes,
      vendas: p => p.vendas, pontos: p => p.pontos, premio: ordemPremio,
    }
    const g = get[ord.col] || get.posicao
    return [...f].sort((a, b) => {
      const x = g(a), y = g(b)
      const c = typeof x === 'string' ? x.localeCompare(y) : x - y
      return c * ord.dir || a.posicao - b.posicao
    })
  }, [pessoas, casa, ord, noApp, fStatus, statusDe])

  const tot = useMemo(() => ({
    pessoas: pessoas.length,
    indicacoes: pessoas.reduce((s, p) => s + p.indicacoes, 0),
    pontos: pessoas.reduce((s, p) => s + p.pontos, 0),
    vendas: pessoas.reduce((s, p) => s + p.vendas, 0),
  }), [pessoas])

  const escolheram = (premio?.pessoas || []).filter(p => p.escolha)
  const temFiltro = !!(q || fDistrito || fStatus)
  const promo = det?.promocao
  const naoApurada = !!det && pessoas.length === 0

  // Quem pode ser selecionada para o aviso: tem pontos e ainda não escolheu.
  const selecionavel = useCallback((p: Pessoa) => p.pontos > 0 && !noApp.get(p.codigo)?.escolha, [noApp])
  const alternarSel = (codigo: string) => setSel(s => {
    const n = new Set(s)
    if (n.has(codigo)) n.delete(codigo); else n.add(codigo)
    return n
  })
  const visiveisSel = filtradas.filter(selecionavel)
  const todasSel = visiveisSel.length > 0 && visiveisSel.every(p => sel.has(p.codigo))
  const alternarTodas = () => setSel(s => {
    const n = new Set(s)
    if (todasSel) visiveisSel.forEach(p => n.delete(p.codigo)); else visiveisSel.forEach(p => n.add(p.codigo))
    return n
  })
  const faltaAvisar = pessoas.filter(p => selecionavel(p) && noApp.get(p.codigo)?.aviso_status !== 'enviado')

  // O que cada uma escolheu, item por item, com o NOME do brinde (o do app; se
  // não houver, o do Draco). Dinâmico desde 05/11/2026: quantos brindes houver.
  const catalogo = useMemo(() => catalogoDe(det), [det])
  const brindeDe = useCallback((item: string) => {
    const a = premio?.brindes.find(b => b.item === item)
    const c = catalogo.find(b => b.item === item)
    const pts = a?.pontos ?? c?.pontos ?? 0
    return { nome: a?.nome || brindeCurto(c?.nome || null) || `Brinde de ${faixaTxt(pts)}`, pts }
  }, [premio, catalogo])
  const itensDe = useCallback((e: { itens?: { item: string; qtd: number }[] }) => (e.itens || [])
    .filter(i => i.qtd > 0)
    .map(i => ({ item: i.item, qtd: i.qtd, ...brindeDe(i.item) }))
    .sort((a, b) => b.pts - a.pts) as ItemEscolhido[], [brindeDe])
  const escolhidasFiltro = filtradas.map(p => noApp.get(p.codigo)).filter(a => a?.escolha) as PessoaPremio[]
  const separar = useMemo(() => {
    const m = new Map<string, { qtd: number; nome: string; pts: number }>()
    for (const a of escolhidasFiltro) for (const i of itensDe(a.escolha!)) {
      const x = m.get(i.item) || { qtd: 0, nome: i.nome, pts: i.pts }
      x.qtd += i.qtd; m.set(i.item, x)
    }
    return [...m.values()].sort((a, b) => b.pts - a.pts)
  }, [escolhidasFiltro, itensDe])
  // As colunas do Excel: uma por brinde (os da promoção, mais algum antigo que só aparece em escolha).
  const colunasBrinde = useMemo(() => {
    const itens = new Map<string, { nome: string; pts: number }>()
    for (const b of premio?.brindes || []) itens.set(b.item, brindeDe(b.item))
    for (const c of catalogo) if (!itens.has(c.item) && !(premio?.brindes || []).some(b => /^p\d+$/.test(b.item))) itens.set(c.item, brindeDe(c.item))
    return [...itens.entries()].sort((a, b) => b[1].pts - a[1].pts)
  }, [premio, catalogo, brindeDe])
  const rotuloFiltro = { '': 'todas', escolheu: 'já escolheram', falta: 'ainda não escolheram', nao_liberada: 'não liberadas' }[fStatus]
  const tituloPromo = `${det?.promocao.numero ?? ''} · ${premio?.promo?.titulo || tituloDe(det?.promocao.nome || null) || det?.promocao.nome || ''}`

  const reabrir = async (codigo: string) => {
    if (numero == null) return
    setReabrindo(codigo)
    try {
      const d = await getJson(`/api/incentivos/${numero}/reabrir/${codigo}`, { method: 'POST', body: '{}' })
      setPremio(p => ({ ...(p as Premio), ...d }))
    } catch (e: any) { setPremioErro(`Não reabriu: ${e.message}`) } finally { setReabrindo(null) }
  }

  const baixarXlsx = async () => {
    if (!det) return
    setBaixando(true)
    try {
      const XLSX = await import('xlsx')
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(filtradas.map(p => {
        const a = noApp.get(p.codigo)
        return {
          'Posição': p.posicao, 'Código': p.codigo, 'Nome': p.nome, 'Tipo': tipoTxt(p.tipo),
          'Grupo': p.grupoNome, 'Cód. grupo': p.grupo, 'Distrito': p.distritoNome,
          'Semanas ativas': p.semanasAtivas, 'Recrutas': p.indicacoes, 'Vendas': p.vendas, 'Pontos': p.pontos,
          'Situação': a?.escolha ? 'Escolheu' : a ? 'Não escolheu' : 'Não liberada',
          'Aviso': a ? premioTxt(a) : '',
          'Itens escolhidos': a?.escolha ? itensDe(a.escolha).map(i => `${i.qtd} × ${i.nome}`).join(' + ') : '',
          ...Object.fromEntries(colunasBrinde.map(([item, b]) => [
            `${b.nome} (${b.pts} ${b.pts === 1 ? 'pt' : 'pts'})`,
            a?.escolha ? (a.escolha.itens.find(i => i.item === item)?.qtd || 0) : '',
          ])),
          'Escolheu em': a?.escolha?.registrada_em || '',
        }
      })), 'Incentivos')
      if (separar.length) XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(separar.map(i => ({ 'Brinde': i.nome, 'Quantidade': i.qtd }))), 'Separar')
      XLSX.writeFile(wb, `incentivos-promocao-${det.promocao.numero}${fStatus ? '-' + fStatus : ''}.xlsx`)
    } finally {
      setBaixando(false)
    }
  }

  // PDF pela impressão do navegador ("Salvar como PDF"): o relatório abre numa
  // janela própria, formatado para A4, com a MESMA lista filtrada da tela.
  const imprimir = () => {
    if (!det) return
    const esc = (v: any) => String(v ?? '').replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' } as any)[c])
    const linhas = filtradas.map((p, i) => {
      const a = noApp.get(p.codigo)
      const sit = a?.escolha
        ? itensDe(a.escolha).map(it => `<div><b>${it.qtd} ×</b> ${esc(it.nome)}</div>`).join('') + `<small>escolheu em ${esc(dataCurta(a.escolha.registrada_em))}</small>`
        : `<span class="pend">${esc(a ? `não escolheu · ${premioTxt(a)}` : 'não liberada')}</span>`
      return `<tr class="${a?.escolha ? 'ok' : ''}"><td class="n">${i + 1}</td><td><b>${esc(p.nome)}</b><br><small>${esc(p.codigo)} · ${esc(tipoTxt(p.tipo))}</small></td>`
        + `<td>${esc(p.grupoNome)}<br><small>${esc(p.distritoNome)}</small></td><td class="n">${p.pontos}</td><td>${sit}</td></tr>`
    }).join('')
    const html = `<!doctype html><html lang="pt-BR"><head><meta charset="utf-8"><title>Incentivos ${esc(tituloPromo)}</title><style>
      @page { size: A4; margin: 14mm }
      body { font: 12px/1.4 system-ui, -apple-system, Segoe UI, Roboto, sans-serif; color: #111; margin: 0 }
      h1 { font-size: 18px; margin: 0 } .sub { color: #555; margin: 2px 0 12px }
      .sep { border: 1px solid #ccc; border-radius: 8px; padding: 8px 12px; margin-bottom: 14px }
      table { width: 100%; border-collapse: collapse } th, td { text-align: left; vertical-align: top; padding: 5px 6px; border-bottom: 1px solid #ddd }
      th { font-size: 11px; color: #555; border-bottom: 1.5px solid #999 } td.n, th.n { text-align: right; white-space: nowrap }
      tr.ok td { background: #eaf7ef } tr.ok td:first-child { box-shadow: inset 3px 0 #1f9d55 }
      .pend { color: #8a5a00 } small { color: #666 } tr { page-break-inside: avoid }
      * { -webkit-print-color-adjust: exact; print-color-adjust: exact }
    </style></head><body>
      <h1>Incentivos — ${esc(tituloPromo)}</h1>
      <p class="sub">${esc(rotuloFiltro)}${fDistrito ? ' · distrito ' + esc(distritos.find(d => d[0] === fDistrito)?.[1] || '') : ''}${q ? ' · busca "' + esc(q) + '"' : ''} · ${filtradas.length} pessoas · ${contaStatus.escolheu} escolheram · gerado em ${new Date().toLocaleString('pt-BR')}</p>
      ${separar.length ? `<div class="sep">Separar: ${separar.map(i => `<b>${i.qtd} ×</b> ${esc(i.nome)}`).join(' &nbsp;·&nbsp; ')}</div>` : ''}
      <table><thead><tr><th class="n">#</th><th>Nome</th><th>Grupo / distrito</th><th class="n">Pontos</th><th>Prêmio escolhido</th></tr></thead><tbody>${linhas || '<tr><td colspan="5">Ninguém no filtro.</td></tr>'}</tbody></table>
    </body></html>`
    const w = window.open('', '_blank')
    if (!w) { setError('O navegador bloqueou a janela do relatório — libere pop-ups para fin.twms.com.br.'); return }
    w.document.open(); w.document.write(html); w.document.close()
    w.focus(); setTimeout(() => w.print(), 300)
  }

  // PLANOS (21/10/2026): o título grande com o nome da promoção saiu do topo —
  // o cabeçalho do PanelShell agora diz "Incentivos". A promoção (nome, selo,
  // "trocar promoção", semanas e a regra) virou a 1ª PlnBarra; Atualizar/Log/
  // PDF/Excel foram para `acoes`; os números viraram PlnKpi.
  const acoes = (
    <>
      <button onClick={recarregar} disabled={loading || loadingLista} title="Ler de novo do Draco e do app" aria-label="Atualizar"
        className="neu-btn p-2 rounded-lg border border-border disabled:opacity-60">
        <FiRefreshCw className={`w-4 h-4 ${loading || loadingLista ? 'animate-spin' : ''}`} />
      </button>
      {/* O log das reaberturas (23/09/2026): antes era uma linha crua embaixo da tabela. */}
      {!!premio?.reabertas.length && (
        <button onClick={() => setVerLog(true)} title="Histórico das escolhas reabertas"
          className="neu-btn px-2.5 py-1.5 rounded-lg border border-border text-sm flex items-center gap-1.5">
          <FiClock className="w-4 h-4" /> Log <span className="tabular-nums text-xs text-muted-foreground">{num(premio.reabertas.length)}</span>
        </button>
      )}
      {/* PDF e Excel saem da LISTA FILTRADA (situação, busca e distrito). */}
      <button onClick={imprimir} disabled={!filtradas.length || naoApurada} title="Relatório da lista filtrada, para imprimir ou salvar em PDF"
        className="neu-btn px-2.5 py-1.5 rounded-lg border border-border text-sm flex items-center gap-1.5 disabled:opacity-60"><FiPrinter className="w-4 h-4" /> PDF</button>
      <button onClick={baixarXlsx} disabled={!filtradas.length || naoApurada || baixando} title="A lista filtrada em Excel, com os itens escolhidos"
        className="neu-btn px-2.5 py-1.5 rounded-lg border border-border text-sm flex items-center gap-1.5 disabled:opacity-60">
        {baixando ? <FiLoader className="w-4 h-4 animate-spin" /> : <FiDownload className="w-4 h-4" />} Excel
      </button>
    </>
  )

  const toolbar = (
    <div className="flex flex-col gap-4">
      {/* 1 · a promoção (23/09/2026): o nome, o número num selo e as semanas em
          etiquetas. O seletor é invisível por cima do botão "Trocar promoção" —
          a lista nativa, sem o texto longo na tela. */}
      <PlnBarra>
        <PlnBarraRot>Promoção</PlnBarraRot>
        <span className="text-base font-semibold leading-tight truncate min-w-0" title={promo?.nome || ''}>
          {promo ? (premio?.promo?.titulo || tituloDe(promo.nome) || promo.nome) : '—'}
        </span>
        {promo && <span className="neu-tag px-2 py-0.5 rounded-md bg-primary/10 text-primary text-xs font-semibold tabular-nums shrink-0">Promoção {promo.numero}</span>}
        <label className="relative shrink-0 inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground cursor-pointer rounded-md px-1.5 py-1 hover:bg-secondary/60">
          trocar promoção <FiChevronDown className="w-3.5 h-3.5" />
          <select value={numero ?? ''} onChange={e => { setNumero(Number(e.target.value)); setQ(''); setFDistrito(''); setFStatus('') }}
            disabled={loadingLista || !promos.length} aria-label="Trocar de promoção"
            className="absolute inset-0 w-full h-full opacity-0 cursor-pointer">
            {promos.map(p => (
              <option key={p.numero} value={p.numero}>
                {p.numero} · {(p.numero === numero && premio?.promo?.titulo) || tituloDe(p.nome) || p.nome} · {periodo(p.semanaIni, p.semanaFim)}{p.pessoas ? '' : ' · ainda não apurada'}
              </option>
            ))}
          </select>
        </label>
        {promo && (
          <>
            <PlnBarraSep />
            <div className="flex flex-wrap items-center gap-1.5 text-xs text-muted-foreground min-w-0">
              <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-secondary/60 whitespace-nowrap">
                <FiClock className="w-3 h-3" /> recrutas lançadas em <b className="font-medium text-foreground">{periodo(promo.semanaIni, promo.semanaFim)}</b>
              </span>
              {promo.entregaIni && (
                <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-secondary/60 whitespace-nowrap">
                  <FiGift className="w-3 h-3" /> entrega dos brindes em <b className="font-medium text-foreground">{periodo(promo.entregaIni, promo.entregaFim)}</b>
                </span>
              )}
              <span className="truncate opacity-80" title="Nome no Draco">{promo.nome}</span>
            </div>
          </>
        )}
        {/* a regra da promoção (antes ao lado dos números) */}
        {det && <><PlnBarraSep /><Regra det={det} /></>}
      </PlnBarra>

      {error && <Faixa tom="erro" icon={FiAlertTriangle}>{error}</Faixa>}

      {/* Chave do Prêmio no app.twms (06/10/2026): vale para o app inteiro, não só
          para esta promoção. No mesmo cartão da Liberação do painel Vanguard
          (pedido do dono, 06/10): título, o que acontece, a chave e o estado. */}
      {appAcesso && (
        // PLANOS (21/10/2026): o cartão virou PlnBloco (título 16 no cabeçalho do
        // papel) e o texto de leitura subiu de 12 para 13px.
        <PlnBloco titulo="A aba Prêmio no app">
        <div className="px-[18px] py-4">
          <p className="text-[13px] text-muted-foreground mb-3">
            Desligada, ninguém vê a aba Prêmio nem troca os pontos. Ligada, ela aparece para quem tem prêmio liberado. Vale para o app inteiro, não só para esta promoção.
          </p>
          <label className="flex items-center gap-3 cursor-pointer w-fit">
            <NeuSwitch on={appAcesso.aberto} onClick={() => setConfirmarApp(true)} disabled={trocandoApp} />
            <span className="text-sm font-medium">{appAcesso.aberto ? 'Ligada' : 'Desligada'}</span>
            {trocandoApp && <FiLoader className="w-4 h-4 animate-spin text-muted-foreground" />}
          </label>
          {(appAcesso.por || appAcesso.em) && (
            <p className="text-[12.5px] text-muted-foreground mt-2.5">
              Último ajuste{appAcesso.por ? `: ${appAcesso.por}` : ''}{appAcesso.em ? `, ${new Date(appAcesso.em).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}` : ''}
            </p>
          )}
        </div>
        </PlnBloco>
      )}

      {confirmarApp && appAcesso && (
        <ConfirmDialog
          isOpen={true}
          type={appAcesso.aberto ? 'danger' : 'info'}
          title={appAcesso.aberto ? 'Bloquear o Prêmio no app?' : 'Liberar o Prêmio no app?'}
          message={appAcesso.aberto
            ? 'A aba Prêmio some do app.twms para todo mundo. Ninguém consegue ver o saldo nem trocar os pontos até você liberar de novo.'
            : 'A aba Prêmio volta a aparecer no app.twms para quem tem prêmio liberado, e a troca de pontos fica aberta.'}
          details={[
            'Vale para o app inteiro, não só para esta promoção.',
            ...(appAcesso.por ? [`Último ajuste: ${appAcesso.por}`] : []),
          ]}
          confirmText={appAcesso.aberto ? 'Bloquear' : 'Liberar'}
          cancelText="Cancelar"
          closeOnEsc
          onCancel={() => setConfirmarApp(false)}
          onConfirm={trocarAppAcesso}
        />
      )}

      {/* 2 · os números e o prêmio (a regra subiu para a barra da promoção) */}
      {det && (
        <>
          {!naoApurada && (
            <PlnKpis>
              <PlnKpi rotulo="Pontuaram" valor={num(tot.pessoas)} />
              <PlnKpi rotulo="Recrutas" valor={num(tot.indicacoes)} />
              <PlnKpi rotulo="Pontos" tom="ok" valor={num(tot.pontos)} />
              <PlnKpi rotulo="Em vendas" valor={<span title={brl(tot.vendas)}>{brlCurto(tot.vendas)}</span>} />
              {!!premio?.pessoas.length && (
                <PlnKpi rotulo="Escolheram" valor={num(escolheram.length)} pe={<span title="Quem já trocou os pontos no app, de quem foi liberado">de {num(premio.pessoas.length)} liberadas</span>} />
              )}
            </PlnKpis>
          )}
          <PremioBox numero={numero!} det={det} premio={premio} erro={premioErro}
            authenticatedFetch={authenticatedFetch} aoMudar={d => setPremio(p => ({ ...(p as Premio), ...d }))} />
        </>
      )}
    </div>
  )

  if (loadingLista && !promos.length) {
    return (
      <PanelShell titulo="Incentivos" sub="Quem pontuou nas promoções de recrutamento e o prêmio de cada uma no app"
        icone={<FiGift />} acoes={acoes} toolbar={toolbar} corpoMin={460}>
        <div className="flex-1 flex items-center justify-center text-sm text-muted-foreground gap-2">
          <FiLoader className="w-4 h-4 animate-spin" /> lendo as promoções no Draco…
        </div>
      </PanelShell>
    )
  }

  return (
    <PanelShell titulo="Incentivos" sub="Quem pontuou nas promoções de recrutamento e o prêmio de cada uma no app"
      icone={<FiGift />} acoes={acoes} toolbar={toolbar} corpoMin={460}>
      {naoApurada ? (
        <div className="flex-1 flex items-center justify-center p-6">
          <div className="max-w-md text-center space-y-2">
            <FiClock className="w-8 h-8 mx-auto text-muted-foreground" />
            <h2 className="text-base font-semibold">A promoção {promo?.numero} ainda não foi apurada</h2>
            <p className="text-sm text-muted-foreground">
              A classificação aparece aqui assim que a promoção for processada no Draco.
              A regra acima já é a que está cadastrada lá.
            </p>
          </div>
        </div>
      ) : (
        <>
          <PlnBarra className="text-sm">
            <PlnBarraRot>Situação</PlnBarraRot>
            <div className="neu-seg inline-flex items-center gap-1" role="group" aria-label="Filtrar pela situação do prêmio">
              {([['', 'Todas', contaStatus.escolheu + contaStatus.falta + contaStatus.nao_liberada],
                 ['escolheu', 'Já escolheram', contaStatus.escolheu],
                 ['falta', 'Não escolheram', contaStatus.falta],
                 ['nao_liberada', 'Não liberadas', contaStatus.nao_liberada]] as const).map(([k, rot, n]) => (
                <button key={k} onClick={() => setFStatus(k)} aria-pressed={fStatus === k}
                  title={k === 'falta' ? 'Liberadas no app que ainda não trocaram os pontos' : k === 'nao_liberada' ? 'Ainda sem o prêmio no app' : undefined}
                  className={`px-2.5 py-1.5 text-sm font-medium rounded-md transition-colors whitespace-nowrap ${fStatus === k
                    ? (k === 'escolheu' ? 'neu-relief bg-emerald-500/15 text-emerald-800 dark:text-emerald-300' : 'neu-relief bg-primary/10 text-primary')
                    : 'neu-seg-btn text-muted-foreground hover:text-foreground'}`}>
                  {k === 'escolheu' && <FiCheck className="inline w-3.5 h-3.5 mr-1 -mt-0.5" />}{rot} <span className="tabular-nums opacity-70">{num(n)}</span>
                </button>
              ))}
            </div>
            <PlnBarraSep />
            <div className="relative">
              <FiSearch className="absolute left-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
              <input value={q} onChange={e => setQ(e.target.value)} placeholder="nome, código ou grupo…"
                className="neu-input pl-8 pr-7 py-1.5 rounded-lg bg-card border border-border text-sm w-48 min-[1500px]:w-56" />
              {q && <button onClick={() => setQ('')} title="limpar busca"
                className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"><FiX className="w-3.5 h-3.5" /></button>}
            </div>
            <select value={fDistrito} onChange={e => setFDistrito(e.target.value)}
              className="neu-input px-2 py-1.5 rounded-lg bg-card border border-border">
              <option value="">Todos os distritos</option>
              {distritos.map(([cod, nome]) => <option key={cod} value={cod}>{nome}</option>)}
            </select>
            {temFiltro && <button onClick={() => { setQ(''); setFDistrito(''); setFStatus('') }}
              className="text-sm text-muted-foreground underline underline-offset-2 hover:text-foreground">limpar</button>}
          </PlnBarra>

          {/* PLANOS: a contagem "N de M" virou a nota do bloco; a faixa de aviso/
              seleção (BarraAviso) mora dentro do bloco, acima da tabela. */}
          <PlnBloco titulo="Classificação" nota={`${num(filtradas.length)} de ${num(pessoas.length)} pessoas`}
            extra={loading ? <FiLoader className="w-4 h-4 animate-spin text-muted-foreground" /> : undefined}
            className="flex-1 min-h-0 flex flex-col">
            <BarraAviso sel={sel} premio={premio} faltaAvisar={faltaAvisar.length} separar={separar}
              aoSelecionarFalta={() => setSel(new Set(faltaAvisar.map(p => p.codigo)))}
              aoLimpar={() => setSel(new Set())} aoAvisar={() => setAvisar(true)} />
            <TabelaClassificacao linhas={filtradas} ord={ord} onOrd={setOrd}
              abertas={abertas} onAlternar={alternar} recrutasDe={c => recrutas.get(c)}
              noApp={noApp} sel={sel} selecionavel={selecionavel} onSel={alternarSel}
              todasSel={todasSel} onTodas={alternarTodas}
              itensDe={itensDe} reabrir={reabrir} reabrindo={reabrindo} />
          </PlnBloco>
        </>
      )}

      {verLog && premio && (
        <SideModal title="Log de reaberturas" subtitle={`${num(premio.reabertas.length)} escolha(s) reaberta(s) · a mais nova primeiro`} icon={FiClock}
          onClose={() => setVerLog(false)} maxWidth="max-w-xl">
          {/* PLANOS (21/10/2026): cada reabertura é uma caixa com respiro; texto 12.5–14px. */}
          <ul className="space-y-2.5">
            {premio.reabertas.map((r, i) => {
              const pe = pessoas.find(p => p.codigo === r.codigo)
              return (
                <li key={i} className="rounded-xl border border-border bg-card px-4 py-3 text-sm">
                  <div className="flex items-baseline gap-2">
                    <span className="text-[14px] font-semibold truncate">{pe?.nome || r.codigo}</span>
                    <span className="text-[12.5px] text-muted-foreground">{r.codigo}</span>
                    <span className="ml-auto text-[12.5px] text-muted-foreground whitespace-nowrap">{dataHora(r.reaberta_em)}</span>
                  </div>
                  <div className="text-[12.5px] text-muted-foreground mt-1">
                    Reaberta por <span className="text-foreground">{r.reaberta_por || '—'}</span> · tinha escolhido em {dataHora(r.registrada_em)}:
                  </div>
                  {itensDe(r).map(it => <div key={it.item} className="text-[13px] mt-1"><b className="tabular-nums">{it.qtd} ×</b> {it.nome}</div>)}
                </li>
              )
            })}
          </ul>
        </SideModal>
      )}

      {avisar && numero != null && det && premio && (
        <Avisar numero={numero} det={det} premio={premio} codigos={[...sel]}
          getJson={getJson}
          aoFechar={() => setAvisar(false)}
          aoEnviar={async () => { setAvisar(false); setSel(new Set()); await carregarPremio(numero) }} />
      )}
    </PanelShell>
  )
}

function premioTxt(a: PessoaPremio | undefined) {
  if (!a) return ''
  if (a.escolha) return `escolheu ${escolhaTxt(a.escolha)}`
  if (a.aviso_status === 'enviado') return `avisada ${dataCurta(a.avisada_em)}`
  if (a.aviso_status === 'sem_celular') return 'sem celular'
  if (a.aviso_status === 'erro') return 'erro no aviso'
  return 'liberada'
}

// ── A regra da promoção, em pílulas ─────────────────────────────────────────
function Regra({ det }: { det: Detalhe }) {
  const r = det.regra
  if (!r) {
    return <p className="text-xs text-muted-foreground flex items-center gap-1.5"><FiInfo className="w-3.5 h-3.5" /> Esta promoção não tem regra de indicação cadastrada no Draco.</p>
  }
  const pilula = 'px-2 py-0.5 rounded-md bg-secondary/60 whitespace-nowrap'
  const completa = `Cada recruta lançada no período soma os pedidos da semana do lançamento + ${r.semanasAnalise}: `
    + `de ${brl(r.valorMin)} a ${brl(r.valorMax)} vale 1 ponto; acima, 2 pontos (teto por recruta).`
    + (r.indicanteAtivo && r.indicanteValorMin != null ? ` Quem indicou precisa ter comprado ${brl(r.indicanteValorMin)} em ${periodo(r.indicanteSemanaIni, r.indicanteSemanaFim)}.` : '')
  return (
    <div className="flex flex-wrap items-center gap-1.5 text-xs text-muted-foreground cursor-help" title={completa}>
      <FiInfo className="w-3.5 h-3.5 shrink-0" aria-label="Regra (passe o mouse para ler inteira)" />
      <span className={pilula}>janela: lançamento + {r.semanasAnalise} semanas</span>
      <span className={pilula}><strong className="text-foreground font-medium">{brl(r.valorMin)} – {brl(r.valorMax)}</strong> = 1 pt · acima = 2 pts</span>
      {r.indicanteAtivo && r.indicanteValorMin != null && (
        <span className={pilula}>indicante ≥ {brl(r.indicanteValorMin)}</span>
      )}
    </div>
  )
}

// ── O prêmio no app: nome da promoção e os brindes com foto ─────────────────
// 05/11/2026: DINÂMICO — um cartão por brinde do Draco (PROMBRINDES), quantos
// houver e em qualquer faixa (a 912 tem tigela 1, bolsa OU buddy 2, carrinho 4).
// Promoção antiga já liberada com os brindes "de 1 e de 2" (911) mostra os dela.
function PremioBox({ numero, det, premio, erro, authenticatedFetch, aoMudar }: {
  numero: number
  det: Detalhe
  premio: Premio | null
  erro: string
  authenticatedFetch: (url: string, options?: RequestInit) => Promise<Response>
  aoMudar: (d: Partial<Premio>) => void
}) {
  const [titulo, setTitulo] = useState('')
  const [salvando, setSalvando] = useState(false)
  const [falha, setFalha] = useState('')
  useEffect(() => { setTitulo(premio?.promo?.titulo || tituloDe(det.promocao.nome)) }, [premio?.promo?.titulo, det.promocao.nome])

  const catalogo = useMemo(() => catalogoDe(det), [det])
  const salvos = premio?.brindes || []
  const legado = salvos.some(b => /^p\d+$/.test(b.item)) && !!premio?.pessoas.length
  const cartoes: (ItemCatalogo & { salvo: BrindeApp | null })[] = legado
    ? salvos.map(b => ({ item: b.item, pontos: b.pontos, nome: b.nome, faixa: null, salvo: b }))
    : catalogo.map(c => ({ ...c, salvo: salvos.find(b => b.item === c.item) || null }))
  cartoes.sort((a, b) => a.pontos - b.pontos || a.item.localeCompare(b.item))

  const salvar = async (corpo: any) => {
    setSalvando(true); setFalha('')
    try {
      const r = await authenticatedFetch(`/api/incentivos/${numero}/premio`, {
        method: 'PUT', body: JSON.stringify({ nome: det.promocao.nome, catalogo: catalogo.map(({ item, pontos, nome }) => ({ item, pontos, nome })), ...corpo }),
      })
      const d = await r.json().catch(() => null)
      if (!r.ok || !d?.success) throw new Error(d?.error || `erro ${r.status}`)
      aoMudar(d)
    } catch (e: any) { setFalha(`Não gravou: ${e.message}`) } finally { setSalvando(false) }
  }

  // Ao abrir uma promoção ainda não liberada, o app recebe o catálogo do Draco
  // (e leva nome/foto que já tinham sido postos nos brindes antigos de 1 e 2).
  const sincronizou = useRef<number | null>(null)
  useEffect(() => {
    if (!premio || legado || !catalogo.length || sincronizou.current === numero) return
    const falta = catalogo.some(c => !salvos.some(b => b.item === c.item)) || salvos.some(b => /^p\d+$/.test(b.item))
    sincronizou.current = numero
    if (falta) salvar({})
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [premio, numero, legado, catalogo])

  const semFoto = cartoes.filter(c => !c.salvo?.url).length

  // PLANOS (21/10/2026): o cartão virou PlnBloco — "Prêmio no app" é o título
  // do papel (o ícone foi junto), o corpo ganhou respiro p-4 e rótulos 12.5px.
  return (
    <PlnBloco
      titulo={<span className="inline-flex items-center gap-2"><FiGift className="w-4 h-4 text-primary shrink-0" />Prêmio no app</span>}
      nota={cartoes.length ? `${num(cartoes.length)} ${cartoes.length === 1 ? 'brinde' : 'brindes'}${semFoto ? ` · ${num(semFoto)} sem foto` : ''}` : undefined}
      extra={salvando ? <FiLoader className="w-4 h-4 animate-spin text-muted-foreground" /> : undefined}>
    <div className="px-[18px] py-4 flex flex-wrap items-start gap-x-4 gap-y-3 min-w-0">
      <div className="shrink-0 w-[190px] min-[1300px]:w-[220px]">
        <label className="block">
          <span className="block text-[12.5px] text-muted-foreground mb-1.5">Nome da promoção no app</span>
          <input value={titulo} onChange={e => setTitulo(e.target.value)} maxLength={80}
            onBlur={() => { const t = titulo.trim(); if (t && t !== (premio?.promo?.titulo || '')) salvar({ titulo: t }) }}
            className="neu-input block w-full h-9 px-2.5 rounded-lg bg-card border border-border text-sm" />
        </label>
      </div>
      {cartoes.length ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 min-[1700px]:grid-cols-3 gap-3 flex-1 min-w-[260px]">
          {cartoes.map(c => (
            <BrindeCard key={c.item} numero={numero} item={c.item} pontos={c.pontos} faixa={c.faixa} promoNome={det.promocao.nome}
              brinde={c.salvo} padrao={brindeCurto(c.nome)}
              authenticatedFetch={authenticatedFetch} aoMudar={aoMudar}
              aoNome={nome => salvar({ brindes: { [c.item]: nome } })} />
          ))}
        </div>
      ) : (
        <p className="flex-1 text-[13px] text-muted-foreground self-center">Esta promoção não tem brinde cadastrado no Draco.</p>
      )}
      {(erro || falha) && <p className="w-full text-[12.5px] text-red-700 dark:text-red-400">{erro || falha}</p>}
    </div>
    </PlnBloco>
  )
}

function BrindeCard({ numero, item, pontos, faixa, promoNome, brinde, padrao, authenticatedFetch, aoMudar, aoNome }: {
  numero: number
  item: string
  pontos: number
  faixa: string | null
  promoNome: string | null
  brinde: BrindeApp | null
  padrao: string
  authenticatedFetch: (url: string, options?: RequestInit) => Promise<Response>
  aoMudar: (d: Partial<Premio>) => void
  aoNome: (nome: string) => void
}) {
  const input = useRef<HTMLInputElement>(null)
  const [nome, setNome] = useState('')
  const [subindo, setSubindo] = useState(false)
  const [falha, setFalha] = useState('')
  useEffect(() => { setNome(brinde?.nome || padrao) }, [brinde?.nome, padrao])

  const subir = async (f: File) => {
    setSubindo(true); setFalha('')
    try {
      const fd = new FormData()
      fd.append('foto', f)
      fd.append('nome', nome.trim())
      fd.append('pontos', String(pontos))
      fd.append('promoNome', promoNome || '')
      const r = await authenticatedFetch(`/api/incentivos/${numero}/brinde/${encodeURIComponent(item)}`, { method: 'PUT', body: fd })
      const d = await r.json().catch(() => null)
      if (!r.ok || !d?.success) throw new Error(d?.error || `erro ${r.status}`)
      aoMudar(d)
    } catch (e: any) { setFalha(e.message) } finally {
      setSubindo(false)
      if (input.current) input.current.value = ''
    }
  }

  return (
    <div className={`flex gap-3 items-center rounded-lg p-3 min-w-0 border ${brinde?.url ? 'border-border bg-background/60' : 'border-dashed border-primary/40 bg-primary/[0.03]'}`}>
      <button type="button" onClick={() => input.current?.click()} disabled={subindo}
        title={brinde?.url ? 'Trocar a foto' : 'Subir a foto do brinde'}
        className="relative w-16 h-16 shrink-0 rounded-lg overflow-hidden bg-white border border-border grid place-items-center hover:ring-2 hover:ring-primary/40">
        {brinde?.url
          ? <img src={brinde.url} alt={nome} className="w-full h-full object-contain" />
          : <span className="flex flex-col items-center gap-0.5 text-xs text-primary/80"><FiUpload className="w-5 h-5" />foto</span>}
        {subindo && <span className="absolute inset-0 grid place-items-center bg-white/70"><FiLoader className="w-4 h-4 animate-spin" /></span>}
      </button>
      <div className="min-w-0 flex-1 space-y-1.5">
        <div className="flex items-center gap-2 min-w-0">
          <span className="text-[13px] font-semibold text-primary whitespace-nowrap" title={faixa ? `Faixa no Draco: ${faixa}` : undefined}>
            <span className="hidden min-[1300px]:inline">Brinde de </span>{faixaTxt(pontos)}
          </span>
          {!/^p\d+$/.test(item) && <span className="text-[11.5px] text-muted-foreground tabular-nums truncate" title="Código do brinde no Draco">{item}</span>}
          <button type="button" onClick={() => input.current?.click()} disabled={subindo}
            title={brinde?.url ? 'Trocar a foto' : 'Subir a foto do brinde'}
            className="ml-auto text-[12.5px] text-muted-foreground hover:text-foreground inline-flex items-center gap-1 whitespace-nowrap">
            <FiUpload className="w-3.5 h-3.5" /><span className="hidden min-[1300px]:inline">{brinde?.url ? 'trocar foto' : 'subir foto'}</span>
          </button>
        </div>
        <input value={nome} onChange={e => setNome(e.target.value)} maxLength={160}
          placeholder="Nome do brinde"
          onBlur={() => { const n = nome.trim(); if (n !== (brinde?.nome || '') && (n || brinde)) aoNome(n) }}
          title={nome}
          className="neu-input block w-full h-9 px-2.5 rounded-lg bg-card border border-border text-sm" />
        {falha && <div className="text-[12.5px] text-red-700 dark:text-red-400">{falha}</div>}
      </div>
      <input ref={input} type="file" accept="image/jpeg,image/png,image/webp" className="hidden"
        onChange={e => { const f = e.target.files?.[0]; if (f) subir(f) }} />
    </div>
  )
}

// ── A barra do aviso: aparece ao selecionar, ou enquanto o envio anda ───────
function BarraAviso({ sel, premio, faltaAvisar, separar, aoSelecionarFalta, aoLimpar, aoAvisar }: {
  sel: Set<string>
  premio: Premio | null
  faltaAvisar: number
  separar: { qtd: number; nome: string }[]
  aoSelecionarFalta: () => void
  aoLimpar: () => void
  aoAvisar: () => void
}) {
  const env = premio?.envio
  if (env?.rodando) {
    return (
      <div className="mx-4 mt-3 shrink-0 px-3.5 py-2.5 rounded-lg border border-primary/30 bg-primary/5 text-sm flex items-center gap-2">
        <FiLoader className="w-4 h-4 animate-spin text-primary" />
        Avisando no WhatsApp: {num(env.feitos)} de {num(env.total)}
        <span className="text-[12.5px] text-muted-foreground">· {num(env.enviados)} enviadas{env.semCelular ? ` · ${num(env.semCelular)} sem celular` : ''}{env.erros ? ` · ${num(env.erros)} com erro` : ''}</span>
      </div>
    )
  }
  if (!sel.size) {
    // Sem seleção: o que separar (da lista filtrada), o último aviso e o atalho.
    if (!separar.length && !env && !faltaAvisar) return null
    return (
      <div className="shrink-0 px-[18px] py-3 border-b border-border/60 flex flex-wrap items-center gap-x-3 gap-y-1.5 text-[13px]">
        {separar.length > 0 && (
          <span className="flex flex-wrap items-center gap-1.5">
            <span className="text-muted-foreground">Separar:</span>
            {separar.map(i => <span key={i.nome} className="neu-tag px-2 py-0.5 rounded-md bg-emerald-500/15 text-emerald-800 dark:text-emerald-300 font-medium tabular-nums">{num(i.qtd)} × {i.nome}</span>)}
          </span>
        )}
        {env && (
          <span className="flex items-center gap-1 text-primary"><FiCheck className="w-3.5 h-3.5" />
            último aviso: {num(env.enviados)} enviadas{env.semCelular ? `, ${num(env.semCelular)} sem celular` : ''}{env.erros ? `, ${num(env.erros)} com erro (passe o mouse no selo)` : ''}{env.falha ? ` — parou: ${env.falha}` : ''}
          </span>
        )}
        {faltaAvisar > 0 && (
          <button onClick={aoSelecionarFalta} title="Marque as pessoas para liberar o prêmio no app e avisar no WhatsApp"
            className="ml-auto text-primary underline underline-offset-2 hover:text-foreground whitespace-nowrap flex items-center gap-1">
            <FiSend className="w-3.5 h-3.5" /> selecionar as {num(faltaAvisar)} que faltam avisar
          </button>
        )}
      </div>
    )
  }
  return (
    <div className="mx-4 mt-3 shrink-0 px-3.5 py-2 rounded-lg border border-primary/30 bg-primary/5 text-sm flex items-center gap-3">
      <span className="font-medium">{num(sel.size)} selecionada{sel.size > 1 ? 's' : ''}</span>
      <button onClick={aoLimpar} className="text-[13px] text-muted-foreground underline underline-offset-2 hover:text-foreground">limpar</button>
      <button onClick={aoAvisar}
        className="ml-auto neu-btn h-9 px-3.5 rounded-lg bg-primary text-primary-foreground text-sm font-medium flex items-center gap-1.5">
        <FiSend className="w-4 h-4" /> Liberar e avisar no WhatsApp
      </button>
    </div>
  )
}

// ── Confirmação do aviso (painel lateral) ───────────────────────────────────
function Avisar({ numero, det, premio, codigos, getJson, aoFechar, aoEnviar }: {
  numero: number
  det: Detalhe
  premio: Premio
  codigos: string[]
  getJson: (url: string, init?: RequestInit) => Promise<any>
  aoFechar: () => void
  aoEnviar: () => void
}) {
  const [reenviar, setReenviar] = useState(false)
  const [enviando, setEnviando] = useState(false)
  const [falha, setFalha] = useState('')
  const noApp = new Map(premio.pessoas.map(p => [p.codigo, p]))
  const escolhidas = det.pessoas.filter(p => codigos.includes(p.codigo) && p.pontos > 0)
  const jaAvisadas = escolhidas.filter(p => noApp.get(p.codigo)?.aviso_status === 'enviado')
  const vaoReceber = reenviar ? escolhidas.length : escolhidas.length - jaAvisadas.length
  const foto = premio.brindes.find(b => b.url) // vêm por pontos: a do mais barato com foto
  const titulo = premio.promo?.titulo || tituloDe(det.promocao.nome)
  const exemplo = escolhidas[0]
  const modeloOk = premio.modelo?.aprovado === true
  const impede = !modeloOk ? (premio.modelo?.aprovado === false
      ? `O modelo de mensagem "${premio.modelo.nome}" ainda não foi aprovado pela Meta. O botão libera assim que aprovar.`
      : `Não consegui conferir o modelo de mensagem na Meta${premio.modelo?.erro ? ` (${premio.modelo.erro})` : ''}.`)
    : !foto ? 'Suba a foto do brinde antes de avisar: ela vai no topo da mensagem.'
    : !titulo ? 'Escreva o nome da promoção que ela vê no app.'
    : !vaoReceber ? 'Todas as selecionadas já foram avisadas.'
    : ''
  // Não bloqueia (no app o brinde sem foto aparece com 🎁), mas o escritório precisa saber.
  const semFoto = premio.brindes.some(b => /^p\d+$/.test(b.item)) ? []
    : catalogoDe(det).filter(c => !premio.brindes.find(b => b.item === c.item)?.url).map(c => premio.brindes.find(b => b.item === c.item)?.nome || brindeCurto(c.nome))

  const enviar = async () => {
    setEnviando(true); setFalha('')
    try {
      // O campo "Nome da promoção no app" só grava ao sair dele: quem nunca
      // clicou nele tinha o nome só na tela, e o envio parava. Grava antes.
      if (!premio.promo?.titulo && titulo) {
        await getJson(`/api/incentivos/${numero}/premio`, { method: 'PUT', body: JSON.stringify({ nome: det.promocao.nome, titulo }) })
      }
      await getJson(`/api/incentivos/${numero}/avisar`, { method: 'POST', body: JSON.stringify({ codigos: escolhidas.map(p => p.codigo), reenviar, titulo }) })
      aoEnviar()
    } catch (e: any) { setFalha(e.message); setEnviando(false) }
  }

  return (
    <SideModal title="Liberar o prêmio e avisar" subtitle={`${det.promocao.numero} · ${titulo}`} icon={FiSend} onClose={aoFechar}
      footer={<>
        <button onClick={aoFechar} className="neu-btn h-9 px-3.5 rounded-lg border border-border text-sm">Cancelar</button>
        <button onClick={enviar} disabled={!!impede || enviando}
          className="neu-btn h-9 px-3.5 rounded-lg bg-primary text-primary-foreground text-sm font-medium flex items-center gap-1.5 disabled:opacity-50">
          {enviando ? <FiLoader className="w-4 h-4 animate-spin" /> : <FiSend className="w-4 h-4" />} Avisar {num(vaoReceber)} pessoa{vaoReceber === 1 ? '' : 's'}
        </button>
      </>}>
      {/* PLANOS (21/10/2026): o corpo da gaveta em duas caixas com respiro p-4. */}
      <div className="rounded-xl border border-border p-4 text-sm space-y-2">
        <p><strong>{num(escolhidas.length)}</strong> pessoa{escolhidas.length === 1 ? '' : 's'} com pontos {escolhidas.length === 1 ? 'ganha' : 'ganham'} a aba <strong>Prêmio</strong> no app.twms, com os pontos de hoje no Draco.</p>
        {jaAvisadas.length > 0 && (
          <label className="flex items-center gap-2 text-[12.5px] text-muted-foreground">
            <input type="checkbox" checked={reenviar} onChange={e => setReenviar(e.target.checked)} />
            {num(jaAvisadas.length)} já foram avisadas — mandar a mensagem de novo para elas
          </label>
        )}
        <p className="text-[12.5px] text-muted-foreground">Quem não tiver celular válido no cadastro fica marcada como "sem celular" na lista.</p>
      </div>

      <div className="rounded-xl border border-border p-4">
        <p className="text-[15px] font-semibold text-foreground mb-3">A mensagem que ela recebe (número do Atendimento)</p>
        <div className="rounded-xl bg-[#e7f7e1] dark:bg-emerald-950/40 border border-border p-2 max-w-[340px] text-sm text-[#12211f] dark:text-foreground">
          {foto?.url
            ? <img src={foto.url} alt="" className="w-full aspect-[1.6] object-contain bg-white rounded-lg mb-2" />
            : <div className="w-full aspect-[1.6] rounded-lg mb-2 bg-white/60 grid place-items-center text-xs text-muted-foreground">sem foto</div>}
          <p className="leading-snug px-1">
            Olá {primeiro(exemplo?.nome || '') || 'Maria'}! 🎁 Seu Prêmio de Incentivo da promoção <strong>{titulo || '…'}</strong> já está disponível no aplicativo da Clara.
            Você tem {exemplo?.pontos ?? 0} pontos para escolher seus brindes. Toque no botão abaixo para escolher.
          </p>
          <div className="mt-2 pt-1.5 border-t border-black/10 text-center text-[#0b7a8a] font-medium text-sm">Escolher meu prêmio</div>
        </div>
      </div>

      {!impede && semFoto.length > 0 && (
        <Faixa tom="alerta" icon={FiAlertTriangle}>
          {semFoto.length === 1 ? 'Este brinde está sem foto' : `Estes ${semFoto.length} brindes estão sem foto`} — no app ele aparece só com o nome: {semFoto.join(', ')}.
        </Faixa>
      )}
      {impede && <Faixa tom="alerta" icon={FiAlertTriangle}>{impede}</Faixa>}
      {falha && <Faixa tom="erro" icon={FiAlertTriangle}>{falha}</Faixa>}
    </SideModal>
  )
}

// ── Classificação (o antigo .xls) ───────────────────────────────────────────
function TabelaClassificacao({ linhas, ord, onOrd, abertas, onAlternar, recrutasDe, noApp, sel, selecionavel, onSel, todasSel, onTodas, itensDe, reabrir, reabrindo }: {
  linhas: Pessoa[]
  ord: { col: string; dir: number }
  onOrd: (o: { col: string; dir: number }) => void
  abertas: Set<string>
  onAlternar: (codigo: string) => void
  recrutasDe: (codigo: string) => EstadoRecrutas | undefined
  noApp: Map<string, PessoaPremio>
  sel: Set<string>
  selecionavel: (p: Pessoa) => boolean
  onSel: (codigo: string) => void
  todasSel: boolean
  onTodas: () => void
  itensDe: (e: Escolha) => ItemEscolhido[]
  reabrir: (codigo: string) => void
  reabrindo: string | null
}) {
  const [confirma, setConfirma] = useState<string | null>(null)
  return (
    <div className="flex-1 min-h-0 overflow-auto scrollbar-thin neu-table">
      {/* Responsiva (23/09/2026): sem largura mínima — em tela estreita (1366 com
          zoom, notebook) a tabela cortava à direita e o Prêmio sumia. Agora o nome
          QUEBRA em vez de cortar, o Distrito desce para baixo do grupo e o Ativ.
          só aparece com folga. */}
      <table className="w-full table-fixed text-sm">
        <colgroup>
          <col className="w-[34px]" /><col className="w-[44px]" /><col /><col className="w-[17%]" /><col className="hidden min-[1500px]:table-column w-[11%]" />
          <col className="hidden min-[1700px]:table-column w-[56px]" /><col className="w-[70px]" /><col className="hidden min-[1200px]:table-column w-[104px]" /><col className="w-[64px]" /><col className="w-[200px] min-[1300px]:w-[25%]" />
        </colgroup>
        <thead>
          <tr className="text-left text-xs text-muted-foreground">
            <th className={`${stickyTh} pl-3 pr-0 py-2`}>
              <input type="checkbox" checked={todasSel} onChange={onTodas} aria-label="Selecionar todas do recorte"
                title="Selecionar todas do recorte (quem tem pontos e ainda não escolheu)" className="align-middle" />
            </th>
            <Th col="posicao" ord={ord} onOrd={onOrd} dir0={1} className="text-right">#</Th>
            <Th col="nome" ord={ord} onOrd={onOrd} dir0={1}>Nome</Th>
            <Th col="grupo" ord={ord} onOrd={onOrd} dir0={1}>Grupo</Th>
            <Th col="distrito" ord={ord} onOrd={onOrd} dir0={1} className="hidden min-[1500px]:table-cell">Distrito</Th>
            <Th col="ativ" ord={ord} onOrd={onOrd} className="text-right hidden min-[1700px]:table-cell" title="Semanas com pedido no período">Ativ.</Th>
            <Th col="ind" ord={ord} onOrd={onOrd} className="text-right" title="Recrutas que o Draco contou para ela nesta promoção">Recrutas</Th>
            <Th col="vendas" ord={ord} onOrd={onOrd} className="text-right hidden min-[1200px]:table-cell" title="Vendas da própria pessoa no período">Vendas</Th>
            <Th col="pontos" ord={ord} onOrd={onOrd} className="text-right">Pontos</Th>
            <Th col="premio" ord={ord} onOrd={onOrd} title="O prêmio no app: liberada, avisada, o que escolheu">Prêmio no app</Th>
          </tr>
        </thead>
        <tbody>
          {linhas.map(p => {
            const aberta = abertas.has(p.codigo)
            const a = noApp.get(p.codigo)
            const pode = selecionavel(p)
            return (
            <Fragment key={p.codigo}>
            <tr onClick={() => onAlternar(p.codigo)} title={aberta ? 'Fechar as recrutas' : 'Ver as recrutas'}
              className={`border-t border-border align-top cursor-pointer ${a?.escolha
                ? 'bg-emerald-500/[0.09] hover:bg-emerald-500/[0.14] shadow-[inset_3px_0_0_0_rgb(16,185,129)]'
                : `hover:bg-secondary/50 ${aberta ? 'bg-secondary/40' : ''} ${sel.has(p.codigo) ? 'bg-primary/[0.06]' : ''}`}`}>
              <td className="pl-3 pr-0 py-2" onClick={e => e.stopPropagation()}>
                <input type="checkbox" checked={sel.has(p.codigo)} disabled={!pode} onChange={() => onSel(p.codigo)}
                  aria-label={`Selecionar ${p.nome || p.codigo}`}
                  title={pode ? 'Selecionar para liberar e avisar' : a?.escolha ? 'Já escolheu no app' : 'Sem pontos'} className="mt-0.5" />
              </td>
              <td className="px-2 py-2 text-right tabular-nums text-muted-foreground">{p.posicao}º</td>
              <td className="px-3 py-2 min-w-0">
                <div className="font-medium flex items-start gap-1 leading-snug" title={p.nome || ''}>
                  {aberta ? <FiChevronDown className="w-3.5 h-3.5 shrink-0 mt-0.5 text-primary" /> : <FiChevronRight className="w-3.5 h-3.5 shrink-0 mt-0.5 text-muted-foreground" />}
                  <span className="min-w-0 break-words">{p.nome || '—'}</span>
                </div>
                <div className="text-xs text-muted-foreground pl-[18px]">{p.codigo} · {tipoTxt(p.tipo)}</div>
                {String(p.tipo) === '3' && <div className="pl-[18px] mt-1"><BotaoLider codigo={p.codigo} nome={p.nome} /></div>}
              </td>
              <td className="px-3 py-2 min-w-0">
                <div className="break-words leading-snug">{p.grupoNome || '—'}</div>
                <div className="text-xs text-muted-foreground break-words">
                  {p.grupo}<span className="min-[1500px]:hidden">{p.distritoNome ? ` · ${p.distritoNome}` : ''}</span>
                </div>
              </td>
              <td className="px-3 py-2 min-w-0 hidden min-[1500px]:table-cell"><div className="break-words leading-snug">{p.distritoNome || '—'}</div></td>
              <td className="px-3 py-2 text-right tabular-nums hidden min-[1700px]:table-cell">{p.semanasAtivas}</td>
              <td className="px-3 py-2 text-right tabular-nums">{p.indicacoes}</td>
              <td className="px-3 py-2 text-right tabular-nums whitespace-nowrap hidden min-[1200px]:table-cell">{brl(p.vendas)}</td>
              <td className="px-3 py-2 text-right tabular-nums font-semibold">{p.pontos}</td>
              <td className="px-3 py-2 min-w-0" onClick={a?.escolha ? e => e.stopPropagation() : undefined}>
                {a?.escolha ? (
                  <div className="text-xs leading-snug space-y-0.5">
                    <div className="font-semibold text-emerald-800 dark:text-emerald-300 flex items-center gap-1">
                      <FiCheck className="w-3.5 h-3.5 shrink-0" /> Escolheu em {dataCurta(a.escolha.registrada_em)}
                      <BotaoChamar codigo={p.codigo} nome={p.nome} />
                    </div>
                    {itensDe(a.escolha).map(i => (
                      <div key={i.pts} className="break-words"><b className="tabular-nums">{i.qtd} ×</b> {i.nome}</div>
                    ))}
                    {confirma === p.codigo
                      ? <div>reabrir a escolha?{' '}
                          <button onClick={() => { reabrir(p.codigo); setConfirma(null) }} disabled={reabrindo === p.codigo} className="font-medium text-red-700 dark:text-red-400 underline">{reabrindo === p.codigo ? 'reabrindo…' : 'sim'}</button>{' '}
                          <button onClick={() => setConfirma(null)} className="underline text-muted-foreground">não</button></div>
                      : <button onClick={() => setConfirma(p.codigo)} title="Deixa ela escolher de novo no app"
                          className="text-muted-foreground hover:text-foreground inline-flex items-center gap-1"><FiRotateCcw className="w-3 h-3" /> reabrir</button>}
                  </div>
                ) : (
                  <span className="inline-flex items-center gap-1.5 max-w-full">
                    <SeloPremio a={a} />
                    {a && <BotaoChamar codigo={p.codigo} nome={p.nome} />}
                  </span>
                )}
              </td>
            </tr>
            {aberta && (
              <tr className="bg-secondary/40">
                <td colSpan={10} className="p-0 border-t border-border">
                  <RecrutasBox pessoa={p} estado={recrutasDe(p.codigo)} />
                </td>
              </tr>
            )}
            </Fragment>
            )
          })}
          {!linhas.length && (
            <tr><td colSpan={10} className="px-3 py-8 text-center text-sm text-muted-foreground">Ninguém no recorte.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  )
}

// Botão "Chamar" (pedido do diretor, 24/09): abre as Conversas no número
// Atendimento — o que mandou o aviso do prêmio — já na conversa dela. Dentro
// da janela de 24h é conversa normal; fora dela o inbox oferece o convite
// (modelo premio_incentivo_resgate). Quem resolve o número é o fin.
function BotaoChamar({ codigo, nome }: { codigo: string | number; nome: string | null | undefined }) {
  return (
    <button type="button"
      onClick={e => {
        e.stopPropagation()
        const detail: ChamarPedido = { codigo: String(codigo), nome: nome || null }
        window.dispatchEvent(new CustomEvent(EVENTO_CHAMAR, { detail }))
      }}
      title={`Conversar com ${nome?.split(' ')[0] || 'ela'} no WhatsApp`}
      aria-label={`Conversar com ${nome || 'ela'} no WhatsApp`}
      className="shrink-0 inline-flex items-center justify-center w-6 h-6 rounded-full bg-[#25D366] hover:bg-[#1ebe5b] text-white shadow-sm transition-colors">
      <FaWhatsapp className="w-3.5 h-3.5" />
    </button>
  )
}

// Botão roxo "Falar com a líder" (pedido do diretor, 25/09): SÓ nas consultoras
// (tipo 3 no Draco). Abre as Conversas no Atendimento já na conversa com a LÍDER
// do grupo dela; com a janela de 24h fechada, o inbox oferece o convite
// incentivo_falar_lider ("queremos falar sobre o Prêmio de Incentivo da X").
// Quem é a líder (nível 2 do mesmo grupo) o fin pergunta ao app-twms.
function BotaoLider({ codigo, nome }: { codigo: string | number; nome: string | null | undefined }) {
  return (
    <button type="button"
      onClick={e => {
        e.stopPropagation()
        const detail: ChamarPedido = { codigo: String(codigo), nome: nome || null, lider: true }
        window.dispatchEvent(new CustomEvent(EVENTO_CHAMAR, { detail }))
      }}
      title={`Conversar no WhatsApp com a líder de ${nome?.split(' ')[0] || 'esta consultora'}`}
      className="inline-flex items-center gap-1.5 rounded-full bg-violet-600 hover:bg-violet-700 text-white px-2.5 py-1 text-xs font-medium shadow-sm transition-colors whitespace-nowrap">
      <FaWhatsapp className="w-3.5 h-3.5 shrink-0" /> Falar com a líder
    </button>
  )
}

function SeloPremio({ a }: { a: PessoaPremio | undefined }) {
  const base = 'neu-tag inline-block max-w-full truncate px-2 py-0.5 rounded text-xs whitespace-nowrap'
  if (!a) return <span className="text-xs text-muted-foreground">—</span>
  if (a.escolha) return <span className={`${base} bg-emerald-500/15 text-emerald-800 dark:text-emerald-300 font-medium`} title={`Escolheu em ${dataCurta(a.escolha.registrada_em)}`}>✓ {escolhaTxt(a.escolha)}</span>
  if (a.aviso_status === 'enviado') return <span className={`${base} bg-primary/10 text-primary`}>avisada {dataCurta(a.avisada_em)}</span>
  if (a.aviso_status === 'sem_celular') return <span className={`${base} bg-amber-500/15 text-amber-800 dark:text-amber-300`} title="Sem celular válido no cadastro">sem celular</span>
  if (a.aviso_status === 'erro') return <span className={`${base} bg-red-500/10 text-red-700 dark:text-red-400`} title={a.aviso_erro || ''}>erro no aviso</span>
  return <span className={`${base} bg-secondary text-muted-foreground`}>liberada</span>
}

// ── As recrutas de uma pessoa (a linha que abre) ─────────────────────────────
function RecrutasBox({ pessoa, estado }: { pessoa: Pessoa; estado: EstadoRecrutas | undefined }) {
  if (!estado || estado.loading) {
    return (
      <div className="px-4 py-3 text-sm text-muted-foreground flex items-center gap-2">
        <FiLoader className="w-4 h-4 animate-spin" /> Consultando no Draco quem {pessoa.nome?.split(' ')[0] || 'ela'} indicou…
      </div>
    )
  }
  if (estado.error || !estado.data) {
    return <div className="px-4 py-3 text-sm text-red-700 dark:text-red-400">{estado.error || 'Sem resposta do Draco.'}</div>
  }
  const d = estado.data
  const semLabel = (w: number) => `S${String(w).slice(4)}`
  return (
    // PLANOS (21/10/2026): detalhe da linha com respiro (px-5 py-4), título 15px,
    // texto de leitura 12.5–13px (antes 10–12px).
    <div className="px-5 py-4 space-y-3">
      <div className="flex flex-wrap items-baseline gap-x-2 gap-y-1 text-[13px] text-muted-foreground">
        <span className="text-[15px] font-semibold text-foreground">Recrutas de {pessoa.nome}</span>
        <span>{periodo(d.promocao.semanaIni, d.promocao.semanaFim)}</span>
        <span className="tabular-nums">· {num(d.quantidade)} · {brl(d.totalVenda)}</span>
        {d.vendaDepois > 0 && <span className="tabular-nums">· {brl(d.vendaDepois)} depois do fechamento</span>}
        {d.totalDebito > 0 && <span className="tabular-nums font-semibold text-red-700 dark:text-red-400">· {brl(d.totalDebito)} em débito</span>}
        {d.totalDevolvido > 0 && <span className="tabular-nums font-semibold text-amber-700 dark:text-amber-400">· {brl(d.totalDevolvido)} devolvido</span>}
        {d.regra && <span className="tabular-nums font-semibold text-primary">· {faixaTxt(d.totalPontos)} pela regra</span>}
      </div>
      {d.regra && d.totalPontos !== pessoa.pontos && (
        <p className="text-[12.5px] text-amber-800 dark:text-amber-400">
          O Draco apurou {faixaTxt(pessoa.pontos)}; pela regra, com os pedidos de hoje, as recrutas abaixo somam {faixaTxt(d.totalPontos)}.
          A diferença costuma vir de mudança depois da apuração — indicante trocado no cadastro, pedido ou devolução lançados depois.
        </p>
      )}
      {d.quantidade !== pessoa.indicacoes && (
        <p className="text-[12.5px] text-amber-800 dark:text-amber-400">
          O Draco contou {num(pessoa.indicacoes)} recruta(s) nesta promoção; no cadastro, {num(d.quantidade)} lançada(s)
          no período apontam {pessoa.nome?.split(' ')[0] || 'ela'} como quem indicou.
        </p>
      )}
      {!d.recrutas.length ? (
        <p className="text-sm text-muted-foreground">Ninguém indicado nesse período.</p>
      ) : (
        <>
          <p className="text-[12.5px] text-muted-foreground">
            Uma coluna por semana da promoção, mais as duas seguintes — o prazo que ela ainda tem para pôr pedido.
            Antes do lançamento fica vazio. Em vermelho, embaixo da venda, o que ficou em aberto naquela semana.
            A devolução conta desde o lançamento dela, em qualquer semana. Valores em R$.
            {d.regra && <> O fundo destacado é a janela de cada recruta (semana do lançamento + {d.regra.semanasAnalise}): a soma dela
            de {brl(d.regra.valorMin)} a {brl(d.regra.valorMax)} vale +1 ponto, acima disso +2.</>}
          </p>
          <div className="overflow-x-auto scrollbar-thin rounded-lg border border-border bg-card">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-[12.5px] text-muted-foreground">
                  <th className="px-3 py-2 font-medium w-full min-w-[170px]">Recruta</th>
                  <th className="px-3 py-2 font-medium whitespace-nowrap" title="Semana em que ela foi lançada">Lanç.</th>
                  {d.semanas.map(w => (
                    <th key={w.semana} title={w.depois ? 'Depois do fechamento da promoção' : undefined}
                      className={`px-3 py-2 font-medium text-right whitespace-nowrap ${w.depois ? 'border-l border-dashed border-border' : ''} ${w.atual ? 'text-primary' : ''}`}>
                      {semLabel(w.semana)}
                      {w.depois && <span className="block text-xs font-normal">depois</span>}
                      {w.atual && !w.depois && <span className="block text-xs font-normal">atual</span>}
                    </th>
                  ))}
                  <th className="px-3 py-2 font-medium text-right">{d.colunas ? 'Total' : 'Venda no período'}</th>
                  {d.regra && <th className="px-3 py-2 font-medium text-right" title="Pontos que a recruta dá pela regra da promoção">Pontos</th>}
                  <th className="px-3 py-2 font-medium text-right" title="Devolvido desde o lançamento dela, em qualquer semana">Devolução</th>
                  <th className="px-3 py-2 font-medium text-right" title="Não pago nas semanas mostradas">Débito</th>
                </tr>
              </thead>
              <tbody>
                {d.recrutas.map(r => (
                  <tr key={r.codigo} className="border-t border-border align-top">
                    <td className="px-3 py-2">
                      <div>{r.nome || '—'}</div>
                      <div className="text-xs text-muted-foreground tabular-nums">{r.codigo}</div>
                      {r.foiParaBase && (
                        <div className="text-xs text-amber-700 dark:text-amber-400"
                          title="Parou de comprar e o Draco a passou para a BASE DISTRIBUIÇÃO, trocando a indicante. Na apuração ela contava para esta pessoa.">
                          foi para a Base
                        </div>
                      )}
                    </td>
                    <td className="px-3 py-2 tabular-nums text-muted-foreground">{semLabel(r.lancamento)}</td>
                    {r.vendas.map((v, i) => (
                      <td key={i} title={r.janela.includes(d.semanas[i]?.semana) ? 'Janela dela: conta para o ponto' : undefined}
                        className={`px-3 py-2 text-right tabular-nums whitespace-nowrap ${d.semanas[i]?.depois ? 'border-l border-dashed border-border' : ''} ${r.janela.includes(d.semanas[i]?.semana) ? 'bg-primary/[0.07]' : ''}`}>
                        {v == null ? <span className="text-muted-foreground">—</span> : val(v)}
                        {r.debitos[i] != null && (
                          <div className="text-xs font-medium text-red-700 dark:text-red-400" title="Em aberto nos títulos desta semana">{val(r.debitos[i] as number)}</div>
                        )}
                      </td>
                    ))}
                    <td className="px-3 py-2 text-right tabular-nums whitespace-nowrap font-medium">
                      {val(r.total)}
                      {r.depois > 0 && <div className="text-xs font-normal text-muted-foreground">{val(r.depois)} depois</div>}
                    </td>
                    {d.regra && (
                      <td className="px-3 py-2 text-right whitespace-nowrap"
                        title={`${brl(r.valorJanela)} na janela dela (${r.janela.map(semLabel).join(', ') || '—'})`}>
                        {r.pontos > 0
                          ? <span className="neu-tag px-2 py-0.5 rounded bg-primary/10 text-primary text-xs font-medium">+{faixaTxt(r.pontos)}</span>
                          : <span className="text-xs text-muted-foreground">{r.valorJanela > 0 ? `faltou ${val(d.regra.valorMin - r.valorJanela)}` : '—'}</span>}
                      </td>
                    )}
                    <td className="px-3 py-2 text-right tabular-nums whitespace-nowrap">
                      {r.devolvido > 0 ? (
                        <>
                          <span className="font-medium text-amber-700 dark:text-amber-400">{val(r.devolvido)}</span>
                          <div className="text-xs text-muted-foreground">{r.devolucoes.map(x => semLabel(x.semana) + '/' + String(x.semana).slice(0, 4)).join(', ')}</div>
                        </>
                      ) : <span className="text-muted-foreground">—</span>}
                    </td>
                    <td className="px-3 py-2 text-right tabular-nums whitespace-nowrap">
                      {r.debito > 0 ? <span className="font-medium text-red-700 dark:text-red-400">{val(r.debito)}</span> : <span className="text-muted-foreground">—</span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  )
}

function Th({ col, ord, onOrd, dir0 = -1, className = '', title, children }: any) {
  const ativo = ord && ord.col === col
  return (
    <th className={`${stickyTh} px-3 py-2 ${className}`} title={title}>
      <button onClick={() => onOrd(ativo ? { col, dir: -ord.dir } : { col, dir: dir0 })}
        className={`inline-flex items-center gap-1 hover:text-foreground transition-colors truncate max-w-full ${ativo ? 'text-foreground font-medium' : ''}`}>
        {children}
        {ativo
          ? (ord.dir === 1 ? <FiChevronUp className="w-3 h-3 shrink-0" /> : <FiChevronDown className="w-3 h-3 shrink-0" />)
          : <FiChevronDown className="w-3 h-3 shrink-0 opacity-0" />}
      </button>
    </th>
  )
}

function Faixa({ tom, icon: Icon, children }: any) {
  const cls = tom === 'erro'
    ? 'bg-red-500/10 text-red-700 dark:text-red-400 border-red-500/30'
    : 'bg-amber-500/10 text-amber-800 dark:text-amber-400 border-amber-500/30'
  return (
    <div className={`px-3 py-2 rounded-lg border text-sm flex items-start gap-2 ${cls}`}>
      <Icon className="w-4 h-4 shrink-0 mt-0.5" />
      <span className="leading-snug">{children}</span>
    </div>
  )
}
